import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { LocationTree } from '@app/interfaces/rm/location';
import { LocationService } from '@services/rm/location.service';

@Component({
    selector: 'app-location',
    templateUrl: './location.component.html',
    styleUrls: ['./location.component.less'],
})
export class LocationComponent implements OnInit {
    @Input() type?: number;
    @Input() values: Array<number> = [];
    @Input() disabled = false;
    locationOptions: LocationTree[] = [];
    loading = false;
    constructor(private locationService: LocationService) {
    }

    ngOnInit(): void {
        this.fetchData();
    }

    async fetchData(): Promise<void> {
        try {
            if (!this.type) {
                return;
            }
            this.loading = true;
            const params = {
            };
            const treeData = await this.locationService.findTree(params);
            this.locationOptions = treeData?.map((item) => {
                return this.mapTree(item);
            });
        } finally {
            this.loading = false;
        }
    }

    mapTree(item: LocationTree): LocationTree {
        return Array.isArray(item.children) && item.children.length > 0 ? {
            ...item,
            children: item.children.map((childItem: LocationTree) => this.mapTree(childItem)),
        } : {
            ...item,
            isLeaf: true
        };
    }
}
